import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsProject } from 'types/cms/collection-types'
import { stringify } from 'qs'

/**
 * Get the projects from the CMS
 *
 * @param {'all' | Language} locale
 * @param {string} slug
 * @returns {Promise<CmsProject[]>}
 */
const getProjects = async (locale: 'all' | Language = Language.DUTCH, slug?: string): Promise<CmsProject[]> => {
  try {
    const query = stringify(
      {
        ...(slug && {
          filters: {
            slug: {
              $ne: slug
            }
          }
        }),
        locale
      },
      {
        addQueryPrefix: true,
        skipNulls: true
      }
    )

    const { data } = await axios.get<CMSApiResponseBody<CmsProject[]>>(`${process.env.CMS_API_URL}/projects${query}`)

    return data.data
  } catch (_) {
    return []
  }
}

export default getProjects
